import React, { useRef, useCallback, useEffect } from "react";
import { DateTimePicker } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import { MultipleSelect } from "../../../Plugin/component";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import "./styles.scss";

export default function ReportFilterLayout(props) {
  // eslint-disable-next-line 
  const [data, setData] = React.useState();
  // eslint-disable-next-line 
  const [index, setIndex] = React.useState();

  // const getOptions = useCallback(
  //   (item) => {
  //     const array = item.data.split("*").map((value, index) => {
  //       return { title: value, value: index + 1 };
  //     });
  //     const optionArray = [{ title: "Tất cả", value: 0 }, ...array];
  //     // setOptionMultiselect(optionArray);
  //     return optionArray;
  //   },
  //   [props.data]
  // );

  const Data = useRef();

  useEffect(() => {
    if (Data !== props.data) {
      Data.current = props.data;
      if (index) {
        setData(props.data[index].content);
      }
    }
    // eslint-disable-next-line 
  }, [props.data]);

  const isRequiredText = useCallback(
    (item) => (item.isRequired === "true" ? true : false),
    []
  );

  const includedHelperText = useCallback((item) => {
    return item.isError && `Vui lòng điền vào trường ${item.name}`;
  }, []);

  // const handleClickOpen = useCallback((value, index, disabled) => {
  //   setData(value);
  //   setIndex(index);
  //   setOpen(true);
  //   setDisabled(disabled);
  // }, []);

  // const handleClose = useCallback(() => {
  //   setOpen(false);
  // }, []);

  //   const onChange = useCallback((value, index, type) => {
  //     props.onChange(value, index, type);
  //   }, []);

  // const handleDownload = useCallback((value) => {
  //   props.handleDownload(value);
  // }, []);

  const reflbl = useRef([]);
  const refcls = useRef([]);

  // const required = "";

  reflbl.current = props.data.map(
    (element, i) => reflbl.current[i] ?? React.createRef()
  );
  refcls.current = props.data.map(
    (element, i) => refcls.current[i] ?? React.createRef()
  );

  // const fn_SetAsigner = (newValue, reason) => {
  //   if (reason === "select-option") {
  //     if (
  //       newValue.some((x) => x.value === 0) ||
  //       (!newValue.some((x) => x.value === 0) &&
  //         newValue.length === valueasigner.length - 1)
  //     ) {
  //       SetAsigner(valueasigner);
  //     } else {
  //       SetAsigner(newValue);
  //     }
  //   } else if (reason === "remove-option") {
  //     if (newValue.some((x) => x.value === 0)) {
  //       var index = newValue.findIndex((x) => x.value === 0);
  //       SetAsigner([...newValue.slice(0, index), ...newValue.slice(index + 1)]);
  //     } else if (
  //       !newValue.some((x) => x.value === 0) &&
  //       newValue.length === valueasigner.length - 1
  //     ) {
  //       SetAsigner();
  //     } else {
  //       SetAsigner(newValue);
  //     }
  //   } else if (reason === "clear") {
  //     SetAsigner();
  //   }
  // };

  // const fn_SetAsigner = (newValue, reason) => {
  //   if (reason === "select-option") {
  //     if (
  //       newValue.some((x) => x.value === 0) ||
  //       (!newValue.some((x) => x.value === 0) &&
  //         newValue.length === optionMultiselect.length - 1)
  //     ) {
  //       setOptionMultiselect(optionMultiselect);
  //     } else {
  //       setOptionMultiselect(newValue);
  //     }
  //   } else if (reason === "remove-option") {
  //     if (newValue.some((x) => x.value === 0)) {
  //       var index = newValue.findIndex((x) => x.value === 0);
  //       setOptionMultiselect([...newValue.slice(0, index), ...newValue.slice(index + 1)]);
  //     } else if (
  //       !newValue.some((x) => x.value === 0) &&
  //       newValue.length === optionMultiselect.length - 1
  //     ) {
  //       setOptionMultiselect();
  //     } else {
  //       setOptionMultiselect(newValue);
  //     }
  //   } else if (reason === "clear") {
  //     setOptionMultiselect();
  //   }
  // };

  return (
    <div className="row layout-body col-md-12">
      {props.data.map((item, index) => {
        let layoutByItem;
        if (item.type === "Input text") {
          layoutByItem = (
            <TextField
              fullWidth
              id="outlined-name"
              label={item.rename !== "" ? item.rename : item.name}
              margin="dense"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) =>
                props.onChange({
                  event: e.target.value,
                  index,
                  type: item.type,
                  item
                })
              }
              value={item.content ? item.content : ""}
              disabled={item.disabled === 1 ? true : false}
              required={isRequiredText(item)}
              error={item.isError}
              helperText={includedHelperText(item)}
            />
          );
        } else if (item.type === "Datetime") {
          layoutByItem = (
            <DateTimePicker
              fullWidth
              animateYearScrolling
              format="dd/MM/yyyy HH:mm"
              label={item.rename !== "" ? item.rename : item.name}
              inputVariant="outlined"
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
              value={item.content ? item.content : new Date()}
              onChange={(event) =>
                props.onChange({ event, index, type: item.type, item })
              }
              disabled={item.disabled === 1 ? true : false}
              required={isRequiredText(item)}
              error={item.isError}
            />
          );
        } else if (item.type === "Combobox") {
          layoutByItem = (
            <Autocomplete
              options={item.data.split("*")}
              size="small"
              getOptionLabel={(option) => option}
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="dense"
                  label={item.rename !== "" ? item.rename : item.name}
                  variant="outlined"
                />
              )}
              renderOption={(option) => (
                <Typography noWrap style={{ fontSize: "14px" }}>
                  {option}
                </Typography>
              )}
              value={item.content ? item.content : null}
              onChange={(e, newValue) =>
                props.onChange({ event: newValue, index, type: item.type, item })
              }
              disabled={item.disabled === 1 ? true : false}
              required={isRequiredText(item)}
              error={item.isError}
            />
          );
        } else if (item.type === "Multiple select") {
          layoutByItem = (
            <div>
              <MultipleSelect
                data={["Tất cả", ...item.data.split("*")]}
                name={item.rename !== "" ? item.rename : item.name}
                value={item.content ? item.content.split("*") : []}
                onChange={(Value) =>
                  props.onChange({
                    event: Value.join("*"),
                    index,
                    type: item.type,
                    name: item.name,
                    item
                  })
                }
                disabled={item.disabled === 1 ? true : false}
                required={isRequiredText(item)}
                error={item.isError}
              />
              {/* <Autocomplete
                multiple
                id="combo-box"
                limitTags={5}
                options={getOptions(item)}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <ThemeProvider theme={theme}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      <Typography noWrap style={{ fontSize: "13px" }}>
                        {option.title}
                      </Typography>
                    </ThemeProvider>
                  </React.Fragment>
                )}
                size="small"
                getOptionLabel={(option) => option.title}
                style={{ width: "100%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="dense"
                    label={item.rename !== "" ? item.rename : item.name}
                    variant="outlined"
                  />
                )}
                className="PlanHandle_0013"
                value={Asigner ? Asigner : []}
                onChange={(e, newValue, reason) =>
                  fn_SetAsigner(newValue, reason)
                }
              /> */}
            </div>
          );
        } else if (item.type === "Input text multiline") {
          layoutByItem = (
            <TextField
              fullWidth
              id="outlined-name"
              label={item.rename !== "" ? item.rename : item.name}
              margin="dense"
              variant="outlined"
              multiline
              rows={2}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) =>
                props.onChange({
                  event: event.target.value,
                  index,
                  type: item.type,
                  item
                })
              }
              value={item.content ? item.content : ""}
              disabled={item.disabled === 1 ? true : false}
              required={isRequiredText(item)}
              error={item.isError}
            />
          );
        } else if (item.type === "Link") {
          if (item.disabled !== 1) {
            layoutByItem = (
              <TextField
                fullWidth
                id="outlined-name"
                label={item.rename !== "" ? item.rename : item.name}
                margin="dense"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) =>
                  props.onChange({
                    event: event.target.value,
                    index,
                    type: item.type,
                    item
                  })
                }
                value={item.content ? item.content : ""}
                required={isRequiredText(item)}
                error={item.isError}
              />
            );
          } else {
            layoutByItem = (
              <div className="layout-link">
                <span className="layout-title">{item.name}</span>
                {/* eslint-disable-next-line  */}
                <a href={item.content} target="_blank">
                  <span>{item.content}</span>
                </a>
              </div>
            );
          }
        } else if (item.type === "Datetime Between") {
          layoutByItem = (
            <div className="itsm-datetime-between">
              <span className="itsm-datetime-between-title">{item.rename !== "" ? item.rename : item.name}</span>
              <DatePicker
                fullWidth
                animateYearScrolling
                format="dd/MM/yyyy"
                label="Từ ngày"
                inputVariant="outlined"
                margin="dense"
                InputLabelProps={{
                  shrink: true,
                }}
                // eslint-disable-next-line 
                value={item.child.map((itemChild) => {
                  if (itemChild.dateType === "DatetimeFrom") {
                    const itemChildValue = itemChild.content
                      ? itemChild.content
                      : new Date();
                    return itemChildValue;
                  }
                })}
                onChange={(event) =>
                  props.onChange({
                    event,
                    index,
                    type: item.type,
                    dateType: "DatetimeFrom",
                    label: item.name,
                  })
                }
              />
              <DatePicker
                fullWidth
                animateYearScrolling
                format="dd/MM/yyyy"
                label="Đến ngày"
                inputVariant="outlined"
                margin="dense"
                InputLabelProps={{
                  shrink: true,
                }}
                // eslint-disable-next-line 
                value={item.child.map((itemChild) => {
                  if (itemChild.dateType === "DatetimeTo") {
                    const itemChildValue = itemChild.content
                      ? itemChild.content
                      : new Date();
                    return itemChildValue;
                  }
                })}
                onChange={(event) =>
                  props.onChange({
                    event,
                    index,
                    type: item.type,
                    dateType: "DatetimeTo",
                    label: item.name,
                  })
                }
              />
            </div>
          );
        }
        return (
          <div
            key={index}
            className={`col-md-${item.flex} ${item.type
              .split(" ")
              .join("-")}-field ${
              item.type !== "Datetime Between" && "flex-item-right"
            }`}
            style={{ marginBottom: "10px" }}
          >
            {layoutByItem}
          </div>
        );
      })}
      {/* <UploadFileDialog
        open={open}
        handleClose={handleClose}
        data={data}
        index={index}
        disabled={disabled}
        onChange={onChange}
        handleDownload={handleDownload}
      /> */}
    </div>
  );
}

// const UploadFileDialog = React.memo((props) => {
//   const refUploadFile = useRef();
//   const [fileList, setFileList] = React.useState();
//   const [isLoading, setIsLoading] = React.useState(false);
//   const [data, setData] = React.useState();

//   React.useEffect(() => {
//     if (props.data) {
//       setData([...props.data]);
//     }
//   }, []);

//   React.useEffect(() => {
//     if (!props.open) {
//       setFileList();
//     }
//   }, [props.open]);

//   React.useEffect(() => {
//     if (props.data) {
//       setData([...props.data]);
//     } else {
//       setData();
//     }
//   }, [props.data]);

//   return (
//     <Dialog
//       open={props.open}
//       onClose={props.handleClose}
//       aria-labelledby="alert-dialog-title"
//       aria-describedby="alert-dialog-description"
//       className="upload-file-tab-dialog"
//     >
//       <div className="upload-file-tab">
//         <div className="upload-file-tab-title">
//           <span>Chọn file của bạn</span>
//           <span className="note">File hợp lệ Zip</span>
//         </div>
//         <div
//           className="upload-file-tab-selection"
//           onClick={() => !props.disabled && refUploadFile.current.click()}
//         >
//           <MdCloudUpload />
//           <span className="note">click để chọn file</span>
//         </div>
//         {data ? (
//           <div className="upload-file-tab-list-file">
//             <MdInsertDriveFile className="file-icon" />
//             <div className="upload-file-tab-list-file-name">
//               <div className="upload-file-tab-list-file-name-top">
//                 <span>{props.data}</span>
//               </div>
//               <MdDownloadForOffline
//                 className="donwload-icon"
//                 onClick={() => props.handleDownload(props.data.split("-")[0])}
//               />
//               <MdCheckCircle className="check-icon" />
//             </div>
//           </div>
//         ) : (
//           fileList &&
//           fileList.map((item, index) => (
//             <div className="upload-file-tab-list-file" key={item}>
//               <MdInsertDriveFile className="file-icon" />
//               <div className="upload-file-tab-list-file-name">
//                 <div className="upload-file-tab-list-file-name-top">
//                   <span>{item.name}</span>
//                 </div>
//                 {isLoading ? (
//                   <Spin className="loading-icon" color="var(--itsm-bg-btn)" />
//                 ) : (
//                   <MdCancel className="error-icon" />
//                 )}
//               </div>
//             </div>
//           ))
//         )}

//         <div className="upload-file-tab-btn-handle">
//           <Button
//             onClick={() => {
//               if (fileList) {
//                 setIsLoading(true);
//                 // props.onChange(fileList, props.index, "File");
//               } else {
//                 NotificationManager.warning("Vui lòng chọn file");
//               }
//             }}
//             className="btn-upload-file"
//             variant="contained"
//             startIcon={<MdFileUpload />}
//           >
//             Upload file
//           </Button>
//           <Button
//             onClick={props.handleClose}
//             className="btn-close"
//             variant="contained"
//             startIcon={<MdClose />}
//           >
//             Đóng
//           </Button>
//         </div>
//       </div>
//       <input
//         accept=".zip,.7zip"
//         id="contained-button-file"
//         type="file"
//         style={{ display: "none" }}
//         ref={refUploadFile}
//         onChange={(e) => {
//           setData();
//           setIsLoading(false);
//           setFileList(onChangeFile(e.target.files));
//           //props.onChange(onChangeFile(e.target.files), props.index, props.data.type)
//         }}
//       />
//     </Dialog>
//   );
// });

// const onChangeFile = (value) => {
//   let FileList = [];
//   Array.from(value).forEach((file) => {
//     if (
//       file.type &&
//       "zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed".includes(
//         file.type
//       )
//     ) {
//       FileList.push(file);
//     } else {
//       NotificationManager.warning(
//         "File " + file.name + " Không đúng định dạng"
//       );
//     }
//   });
//   return FileList;
// };
